import { rhea } from "../data/products/wesaudio/rhea";
import { dione } from "../data/products/wesaudio/dione";
import { hyperion } from "../data/products/wesaudio/hyperion";
import { mimas } from "../data/products/wesaudio/mimas";
import { titan } from "../data/products/wesaudio/titan";
import { phoebe } from "../data/products/wesaudio/phoebe";
import { ngbuscomp } from "../data/products/wesaudio/ngbuscomp";
import { odd } from "../data/products/purpleAudio/5E1Odd";
import { action } from "../data/products/purpleAudio/5C1Action";
import { mc77 } from "../data/products/purpleAudio/mc77";
import { biz } from "../data/products/purpleAudio/5M1Biz";
import { sweetTenRack } from "../data/products/purpleAudio/sweetTen";
import { ng76 } from "../data/products/wesaudio/ng76";
import { distressorel8xPair } from "../data/products/empiricalLabs/distressorel8xPair";
import { elx7Fatso } from "../data/products/empiricalLabs/elx7Fatso";
import { derrEsser } from "../data/products/empiricalLabs/derrEsser";
import { docDerr } from "../data/products/empiricalLabs/docDerr";
import { vivid } from "../data/products/mother/vivid";
import { wai2950 } from "../data/products/mother/wai2950";
import { kamaya } from "../data/products/mother/kamaya";
import { pump } from "../data/products/empiricalLabs/pump";
import { ngTubeEq } from "../data/products/wesaudio/ngTubeEQ";
import { ngTubeComp } from "../data/products/wesaudio/ngTubeComp";
import { pandora } from "../data/products/wesaudio/pandora";
import { stereoComp33609 } from "../data/products/neve/33609";
import { cremeRC } from "../data/products/tegeler/cremeRC";
import { preBX } from "../data/products/popeAudio/preBX";
import { bax2020Beast } from "../data/products/popeAudio/BAX2020Beast";
// import { pants } from "../data/products/purpleAudio/5M2Pants";
// import { mythvca500 } from "../data/products/tegeler/mythvca500";
// import { creme } from "../data/products/tegeler/creme";
// import { dirtyC } from "../data/products/popeAudio/dirtyC";
import { dirtyC500 } from "../data/products/popeAudio/dirtyC500";
import { tubesummingmixer } from "../data/products/tegeler/tubesummingmixer";
import { neve8801 } from "../data/products/neve/8801";
import { neveRMX16 } from "../data/products/neve/rnx16";
import { genesysblackg32 } from "../data/products/neve/genesysblackg32";
import { ng78 } from "../data/products/wesaudio/ng78";
import { quag576 } from "../data/products/quagliardi/576";
import { quag501 } from "../data/products/quagliardi/501+";
import { quagDia } from "../data/products/quagliardi/DIA";
import { quagPowergrid10 } from "../data/products/quagliardi/powergrid10";
import { quagPowergridDuo } from "../data/products/quagliardi/powergridDuo";
import { quagPowergrid2 } from "../data/products/quagliardi/powergrid2";
import { lcpq4040Stereo } from "../data/products/miadAudio/lcpq4040Stereo";

export const featuredProductData = [
  kamaya,
  wai2950,
  vivid,
  pump,
  phoebe,
  dione,
  hyperion,
  ngbuscomp,
  ngTubeEq,
  ngTubeComp,
  pandora,
  elx7Fatso,
  stereoComp33609,
  neve8801,
  neveRMX16,
  distressorel8xPair,
  cremeRC,
  lcpq4040Stereo,
  mc77,
  ng78,
  ng76,
  rhea,
  mimas,
  quag501,
  quag576,
  quagDia,
  action,
  biz,
  preBX,
  bax2020Beast,
  dirtyC500,
  odd,
  derrEsser,
  docDerr,
  tubesummingmixer,
  titan,
  sweetTenRack,
  quagPowergrid2,
  quagPowergridDuo,
  quagPowergrid10,
  genesysblackg32,
];
